import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import {
  Accordion, AccordionContent, AccordionItem, AccordionTrigger,
} from "../components/ui/accordion";
import { Reveal, Eyebrow, Button } from "../components/primitives";
import { Seo } from "../components/Seo";
import { api } from "../lib/api";

export default function FAQ() {
  const { data: faqs = [] } = useQuery({
    queryKey: ["faqs"],
    queryFn: async () => (await api.get("/faqs")).data,
  });

  return (
    <>
      <Seo
        title="FAQ"
        description="Answers to common questions about Glam Wagon — why we accept donations, how funds are used, booking, service areas and our long-term vision."
        schema={{
          "@context": "https://schema.org",
          "@type": "FAQPage",
          mainEntity: faqs.map((f) => ({
            "@type": "Question",
            name: f.question,
            acceptedAnswer: { "@type": "Answer", text: f.answer },
          })),
        }}
      />
      <section className="pt-40 pb-16 max-w-3xl mx-auto px-6 lg:px-12" data-testid="faq-hero">
        <Reveal>
          <Eyebrow>Questions & answers</Eyebrow>
          <h1 className="font-serif text-5xl sm:text-6xl leading-[1] tracking-tight mt-6 text-ink">
            Everything you might ask.
          </h1>
        </Reveal>
      </section>

      <section className="max-w-3xl mx-auto px-6 lg:px-12 pb-20">
        <Reveal delay={0.1}>
          <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
            {faqs.map((f, i) => (
              <AccordionItem key={f.question} value={`item-${i}`} className="border-line">
                <AccordionTrigger data-testid={`faq-q-${i}`} className="text-left font-serif text-xl sm:text-2xl text-ink hover:no-underline py-6">
                  {f.question}
                </AccordionTrigger>
                <AccordionContent className="text-ink-soft text-base leading-relaxed pb-6">
                  {f.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </section>

      <section className="max-w-3xl mx-auto px-6 lg:px-12 pb-28 text-center">
        <Reveal>
          <p className="text-ink-soft text-lg">Still curious about what we're building?</p>
          <div className="mt-6 flex justify-center gap-4">
            <Button as={Link} to="/support" data-testid="faq-support-btn">Support the vision</Button>
            <Button as={Link} to="/contact" variant="outline" data-testid="faq-contact-btn">Contact us</Button>
          </div>
        </Reveal>
      </section>
    </>
  );
}
